var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 193,
    height: 173,
    viewBox: "0 0 193 173",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.86957 27.9536C17.6733 8.00938 41.4007 17.7827 47.4754 22.3521C42.7467 28.6387 21.5107 44.9611 7.86957 27.9536Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8301 27.3934L42.0296 23.1223M7.86957 27.9536C17.6733 8.00938 41.4007 17.7827 47.4754 22.3521C42.7467 28.6387 21.5107 44.9611 7.86957 27.9536Z",
    stroke: "#D89F5B",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7712 26.5532L23.2969 19.207",
    stroke: "#D89F5B",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5688 25.4503L30.1913 19.305M33.2425 24.3651L36.3241 20.2682",
    stroke: "#D89F5B",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1806 86.7508C68.855 91.6605 64.8525 117.008 61.817 123.977C54.6048 120.835 33.8014 103.965 47.1806 86.7508Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6443 90.4734L59.8045 118.858M47.1806 86.7508C68.855 91.6605 64.8525 117.008 61.817 123.977C54.6048 120.835 33.8014 103.965 47.1806 86.7508Z",
    stroke: "#D89F5B",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8399 96.0573L59.2676 99.7281",
    stroke: "#D89F5B",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7217 103.386L60.7718 106.457M56.5575 110.599L61.2575 112.646",
    stroke: "#D89F5B",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2935 47.0003C112.711 36.1905 126.648 57.7375 129.038 64.9531C121.571 67.4273 94.8195 68.749 93.2935 47.0003Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M96.868 48.7955L124.123 62.4846M93.2935 47.0003C112.711 36.1905 126.648 57.7375 129.038 64.9531C121.571 67.4273 94.8195 68.749 93.2935 47.0003Z",
    stroke: "#D89F5B",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M102.23 51.4885L110.956 48.5973",
    stroke: "#D89F5B",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M109.267 55.0229L116.566 52.6043M116.192 58.5013L121.059 56.8889",
    stroke: "#D89F5B",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5497 67.1183C102.059 64.8104 103.115 60.0465 100.752 56.4539C100.422 55.9526 99.9542 55.4227 99.5409 54.9763C102.718 52.5277 103.495 48.0671 101.242 44.6416C98.989 41.216 94.5021 40.2172 91.0788 42.1096C90.8876 41.6369 90.6415 41.0806 90.3118 40.5793C87.949 36.9867 83.24 36.0142 79.6474 38.377C76.9738 40.1354 75.7333 43.3449 76.3529 46.2888C74.9656 46.3633 73.5212 46.7148 72.2679 47.5391C68.7588 49.8469 67.7028 54.6108 70.0656 58.2035C71.3844 60.2087 73.4573 61.3588 75.5634 61.6493C74.9124 63.7532 75.2308 66.0572 76.5496 68.0624C78.8574 71.5715 83.6213 72.6275 87.214 70.2647C88.4672 69.4405 89.4171 68.337 89.9801 67.0092C92.4378 68.7442 95.8761 68.8766 98.5497 67.1183Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M93.483 61.2345C93.7864 61.6959 94.4065 61.824 94.868 61.5205C95.3294 61.217 95.4575 60.5969 95.154 60.1355C94.8505 59.6741 94.2304 59.546 93.769 59.8495C93.3076 60.1529 93.1795 60.773 93.483 61.2345Z",
    fill: "#D89F5B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0279 49.5056C94.3314 49.9671 94.9515 50.0951 95.4129 49.7917C95.8743 49.4882 96.0024 48.8681 95.6989 48.4067C95.3954 47.9452 94.7753 47.8172 94.3139 48.1207C93.8525 48.4241 93.7244 49.0442 94.0279 49.5056Z",
    fill: "#D89F5B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8103 53.0607C97.2506 53.1314 99.4335 54.4487 100.752 56.4539C103.06 59.963 102.059 64.8104 98.55 67.1183C95.8763 68.8766 92.5215 68.6893 90.0353 67.0928",
    stroke: "#D89F5B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4006 61.8253C91.2685 64.9648 89.9709 68.4514 87.2137 70.2647C83.7046 72.5726 78.8571 71.5715 76.5493 68.0624C75.2855 66.1407 74.9956 63.6982 75.6467 61.5944",
    stroke: "#D89F5B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7299 60.4058C77.2208 62.7137 72.3733 61.7126 70.0655 58.2035C67.7576 54.6944 68.7587 49.8469 72.2678 47.5391C73.5211 46.7149 74.9106 46.2798 76.3527 46.2888",
    stroke: "#D89F5B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0984 50.8268C78.4081 50.3233 77.885 49.7098 77.4454 49.0414C75.1375 45.5323 76.1386 40.6848 79.6477 38.377C83.1568 36.0691 88.0043 37.0702 90.3121 40.5793C90.6418 41.0806 90.9429 41.7204 91.189 42.2767",
    stroke: "#D89F5B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6965 46.2487C88.2332 44.6989 89.2953 43.402 90.6321 42.5228C94.1412 40.215 98.9886 41.216 101.296 44.7251C103.439 47.9836 102.746 52.3892 99.7076 54.8664",
    stroke: "#D89F5B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2627 53.2972L92.0225 50.8245",
    stroke: "#D89F5B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9942 52.3954L84.7725 48.172",
    stroke: "#D89F5B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5122 54.3276L79.7152 54.1312",
    stroke: "#D89F5B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4954 56.0167L91.5312 58.4487",
    stroke: "#D89F5B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8311 56.3328L84.1684 60.5382",
    stroke: "#D89F5B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7542 55.605C85.3915 56.574 86.6937 56.8429 87.6627 56.2056C88.6317 55.5683 88.9006 54.2662 88.2633 53.2972C87.626 52.3281 86.3238 52.0592 85.3548 52.6965C84.3858 53.3338 84.1169 54.636 84.7542 55.605Z",
    stroke: "#D89F5B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0425 45.36C83.346 45.8214 83.9661 45.9494 84.4275 45.646C84.889 45.3425 85.017 44.7224 84.7136 44.261C84.4101 43.7995 83.79 43.6715 83.3286 43.975C82.8671 44.2784 82.7391 44.8985 83.0425 45.36Z",
    fill: "#D89F5B"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6636 54.5219C75.9671 54.9834 76.5872 55.1114 77.0486 54.808C77.5101 54.5045 77.6381 53.8844 77.3346 53.423C77.0312 52.9615 76.4111 52.8335 75.9497 53.137C75.4882 53.4404 75.3602 54.0605 75.6636 54.5219Z",
    fill: "#D89F5B"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M82.147 64.3809C82.4505 64.8423 83.0706 64.9704 83.532 64.6669C83.9935 64.3634 84.1215 63.7433 83.818 63.2819C83.5146 62.8205 82.8945 62.6924 82.4331 62.9959C81.9716 63.2994 81.8436 63.9195 82.147 64.3809Z",
    fill: "#D89F5B"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M148.11 137.091C154.756 115.885 179.697 121.924 186.397 125.513C182.683 132.448 164.186 151.819 148.11 137.091Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M151.938 135.933L181.133 127.105M148.11 137.091C154.756 115.885 179.697 121.924 186.397 125.513C182.683 132.448 164.186 151.819 148.11 137.091Z",
    stroke: "#D89F5B",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M157.681 134.197L162.021 126.094",
    stroke: "#D89F5B",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M165.219 131.917L168.85 125.139M172.637 129.674L175.058 125.155",
    stroke: "#D89F5B",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M162.653 151.19C160.442 160.634 151.178 165.552 141.733 163.341C132.288 161.13 126.072 152.589 128.282 143.144C132.362 125.715 144.527 132.979 148.519 133.913C153.095 134.985 166.71 133.858 162.653 151.19Z",
    fill: "white",
    stroke: "#D89F5B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M141.921 137.093C144.191 139.679 150.309 141.624 153.313 139.76",
    stroke: "#D89F5B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M135.136 137.559C131.527 141.131 130.955 146.645 132.036 150.801",
    stroke: "#D89F5B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M135.95 143.296C134.785 146.515 134.812 149.91 136.573 152.479",
    stroke: "#D89F5B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M133.907 154.217C134.206 154.698 134.601 155.202 134.9 155.682",
    stroke: "#D89F5B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M148.065 127.953C149.874 132.074 148.894 136.261 147.57 140.162",
    stroke: "#D89F5B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactBackground);
export default __webpack_public_path__ + "static/media/contact_background.9cbb1deb88ea7c1d1b694fbf753ed227.svg";
export { ForwardRef as ReactComponent };